import { PlantPerformanceFormStep } from '@/types/forms/formSteps/plantPerformanceFormStep';
import { photovoltaicFormGroup } from './plantPerformance/photovoltaic';
import { storageFormGroup } from './plantPerformance/storage';
import { generatorFormGroup } from './plantPerformance/generator';
import { CheckboxField } from '@/types/forms/fields/checkboxField';
import { checked } from '@/validators/checked';
import { inverterFormGroup } from './plantPerformance/inverter';
import { alwaysFalse } from '@/validators/alwaysFalse';
import { FormElement } from '@/types/forms/formElement';
import { cloneDeep as _cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { FormField } from '@/types/forms/fields/formField';

const minOverallApparentPowerValidator = (
    model: PlantPerformanceFormStep,
    min: number,
) => {
    return (
        (typeof model.inverter.inverterOverallApparentPower === 'number' &&
            model.inverter.inverterOverallApparentPower > min) ||
        (typeof model.generator.generatorOverallApparentPower === 'number' &&
            model.generator.generatorOverallApparentPower > min)
    );
};

export const proofOfConformityValidator = (
    model: PlantPerformanceFormStep,
): boolean => minOverallApparentPowerValidator(model, 30);

const inverterStorage = _cloneDeep(inverterFormGroup);
inverterStorage.inverterModules.items.forEach((module) => {
    module.id = new FormField<string>({ value: String(uuidv4()) });
});

export const plantPerformanceFormStep = new PlantPerformanceFormStep({
    photovoltaic: photovoltaicFormGroup,
    inverter: inverterFormGroup,
    inverterStorage,
    storage: storageFormGroup,
    generator: generatorFormGroup,
    certificateHint: new CheckboxField({
        validators: {
            checked,
        },
    }),
    overallNominalPowerNotMatchingTotalPlantPerformanceValueTypeWarning: new FormElement(
        {
            validators: {
                alwaysFalse,
            },
        },
    ),
    storageHasSeparateInverter: new CheckboxField(),
});
